/**
 * Shared Vuetify validation rules for schema-driven persona number fields.
 * Defaults to non-negative (min 0) when the schema does not define a minimum.
 */

function toOptionalNumber(value) {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }
  const numeric = Number(value);
  return Number.isNaN(numeric) ? undefined : numeric;
}

export function resolveNumberFieldBounds(field) {
  const rawMin = field?.min ?? field?.min_value;
  const rawMax = field?.max ?? field?.max_value;
  const min = toOptionalNumber(rawMin);
  const max = toOptionalNumber(rawMax);

  return {
    min: min ?? 0,
    max,
  };
}

export function buildNumberFieldRules(field, t) {
  const { min, max } = resolveNumberFieldBounds(field);
  const rules = [
    (value) => {
      if (value === '' || value === null || value === undefined) {
        return true;
      }
      const numeric = Number(value);
      return !Number.isNaN(numeric) || t('personavalidation.mustBeNumber');
    },
    (value) => {
      if (value === '' || value === null || value === undefined) {
        return true;
      }
      const numeric = Number(value);
      if (Number.isNaN(numeric)) {
        return true;
      }
      return numeric >= min || t('personavalidation.valueMustBeAtLeast', { min });
    },
  ];

  if (max != null) {
    rules.push((value) => {
      if (value === '' || value === null || value === undefined) {
        return true;
      }
      const numeric = Number(value);
      if (Number.isNaN(numeric)) {
        return true;
      }
      return numeric <= max || t('personavalidation.valueMustBeAtMost', { max });
    });
  }

  return rules;
}
